import type { PaymentModuleId } from '@foundation/apis/payments';

export class AuthorizationError extends Error {
  constructor(moduleId: PaymentModuleId, err: Error) {
    super(`Authorization failed for moduleId "${moduleId}"`, { cause: err });
    this.name = 'AuthorizationError';
  }
}
